var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "UiFocusContainer",
    {
      ref: "focusContainer",
      staticClass: "ui-menu",
      class: _vm.classes,
      attrs: { role: "menu", tag: "ul", lazy: "" },
    },
    _vm._l(_vm.options, function (option, index) {
      return _c(
        "UiMenuOption",
        {
          key: index,
          style: [_vm.activeOutline],
          attrs: {
            "disable-ripple": _vm.disableRipple,
            disabled: option[_vm.keys.disabled],
            href: option[_vm.keys.href],
            "icon-props": _vm.iconProps || option[_vm.keys.iconProps],
            icon: _vm.hasIcons ? option[_vm.keys.icon] : null,
            label:
              option[_vm.keys.type] === "divider"
                ? null
                : option[_vm.keys.label] || option,
            "secondary-text": _vm.hasSecondaryText
              ? option[_vm.keys.secondaryText]
              : null,
            target: option[_vm.keys.target],
            type: option[_vm.keys.type],
          },
          nativeOn: {
            click: function ($event) {
              return _vm.selectOption(option)
            },
            keydown: [
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.selectOption(option)
              },
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "esc", 27, $event.key, [
                    "Esc",
                    "Escape",
                  ])
                ) {
                  return null
                }
                return _vm.closeMenu.apply(null, arguments)
              },
            ],
          },
        },
        [_vm._t("option", null, { option: option })],
        2
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }